export const updateTimeForExam = (
  time: Date,
  setTime: (data: { hours: number; minutes: number; seconds: number }) => void,
) => {
  setTime(getTimeForExam(time));
};

export const getTimeForExam = (time: Date) => {
  const now = new Date();
  const distance = time - now; // in milliseconds

  if (distance <= 0) {
    // Exam is over, clear timer
    return { hours: 0, minutes: 0, seconds: 0 };
  }

  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((distance / (1000 * 60)) % 60);
  const seconds = Math.floor((distance / 1000) % 60);

  return { days, hours, minutes, seconds };
};
